var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBinocular = function SvgBinocular(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "fill",
    fill: "#000",
    x: 9.25,
    y: 15,
    width: 5.5,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "fill",
    fill: "#000",
    points: "9.25 6 14.75 6 14.75 8 9.25 8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "stroke",
    stroke: "#000",
    strokeWidth: 1.81069959,
    cx: 5.30041152,
    cy: 16.7942708,
    rx: 4.30041152,
    ry: 4.20572917
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    stroke: "#000",
    strokeWidth: 1.81069959,
    d: "M9.51028807,15.6879611 C9.51028807,10.5509542 9.51028807,7.51014762 9.51028807,6.56554137 C9.51028807,5.148632 8.77801293,4 7.42798354,4 C6.38520794,4 5.49493608,4.68529282 5.14371441,5.65018262 C5.07472278,5.83971912 3.84437627,8.96376688 1.4526749,15.0223259"
  }), /*#__PURE__*/React.createElement("path", {
    className: "stroke",
    stroke: "#000",
    strokeWidth: 1.81069959,
    d: "M22.5473251,15.6879611 C22.5473251,10.5509542 22.5473251,7.51014762 22.5473251,6.56554137 C22.5473251,5.148632 21.81505,4 20.4650206,4 C19.422245,4 18.5319731,4.68529282 18.1807515,5.65018262 C18.1117598,5.83971912 16.8814133,8.96376688 14.4897119,15.0223259",
    transform: "translate(18.518519, 9.843981) scale(-1, 1) translate(-18.518519, -9.843981) "
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "stroke",
    stroke: "#000",
    strokeWidth: 1.81069959,
    cx: 18.6995885,
    cy: 16.7942708,
    rx: 4.30041152,
    ry: 4.20572917
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBinocular, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/binocular.5cae7467.svg";
export { ForwardRef as ReactComponent };